module.exports = __webpack_public_path__ + "static/media/400113_01.11814890.png";